import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardTitle, CardText, Form, Row,Col,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


const ConsultaFactura = () => {
    const [Listado, SetListado] = useState([]);
    const [ListadoPago, SetListadoPagos] = useState([]);
    const [ListadoLinea, SetListadoLinea] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [busqueda, setbusqueda] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    let correo = JSON.parse(user);




   
    const onChangeb = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
              ( item.facturaid+ item.telefono1 + item.enviarNombre )
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            } 
        });
        SetListado(searchData);
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Prestamos/ListaFacturas" );
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if( pendiente){
                SetListado  (data)
            }
            setPendiente(false)
       
           
           
        }
    }

 



    useEffect(() => {
        obtenerDatos();
    },[])
 

    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de prestamos
                </CardHeader>
                <CardBody>
                
                    <Col md="8">
                            <Input type="search" name="busqueda" onChange={(e) => onChangeb(e)} placeholder="Buscar por Nombre / Telefono" ></Input>
                        </Col>
                      
                    <hr></hr>

                    <Tabs >
                        <TabList>
                            <Tab ><b>Faacturas</b></Tab>
                           
                        </TabList>

                        <TabPanel>
                            <tabla className="table">
                                <tr>
                                    <th>Factura</th>
                                    <th>Nombre</th>
                                    <th>Telefono</th>
                                    <th>Fecha</th>
                                    <th>Monto</th>
                                    <th>Usuario</th>
                                </tr>
                            {(Listado.length < 0) ? ('Esperando Registros') : (
                                    Listado.map(x => (<tr>
                                        <td>{x.facturaid }</td>
                                        <td>{x.enviarNombre }</td>
                                        <td>{x.telefono1 }</td>
                                        <td>{moment(x.fecha).format("DD/MM/YYYY") }</td>
                                        <td>{toMoney(x.totalImporte) }</td>
                                        <td>{x.creadoPor }</td>
                                    </tr>
                                    
                                    ))
                                )}
                                </tabla>
                            
                        </TabPanel>
                      
                    </Tabs>


                
                </CardBody>
            </Card>

            

        </>
    )

}
export default ConsultaFactura;